import { Inject, Injectable } from "@angular/core";
import { AppMetaData, AppMetaDataItemNames, CourseEntity, CourseLessonEntity, CourseLessonProgressEntity, CourseLessonSessionEntity, CourseModuleProgressEntity, LessonTypeAllItems, StudentCourseEntity, VideoEntity, VideoLibraryEntity, VideoStreamingProviderEntity } from "../../../meta-data/app-meta-data.service";
import { DevwareMetaData, DwCacheService, DwConfigService, DwConfigServiceToken, DwEventService, DwMetaDataService, DwMetaDataServiceToken, DwOrmData, DwOrmDataService, DwOrmDataServiceToken, DwSecurityTopics, DwSecurityUserService, areEqual, deepCopy } from "@devwareapps/devware-cap";
import { Observable, combineLatest, of } from "rxjs";
import { Router } from "@angular/router";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { VideoPreviewPlayback, VideoThumbnailPreview } from "../models/video-playback.model";


@Injectable({ providedIn: 'root' })
export class VideoRepositoryService {
    apiRoot: string;

     private static eventClientId = Math.random().toString();

    constructor(@Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
        private dwSecurityUserService: DwSecurityUserService,
        private dwCacheService: DwCacheService,
        private dwEventService: DwEventService,
        private router: Router,
        private httpClient: HttpClient,
        @Inject(DwConfigServiceToken)  private dwConfigService: DwConfigService
    ) {
        this.apiRoot = this.dwConfigService.coreConfig.apiRoot;
    }

    getEventClientId(): string {
        return VideoRepositoryService.eventClientId;
    }

    getStreamingProvider(streamingProviderId: number): Observable<VideoStreamingProviderEntity> {
        return this.getStreamingProviders()
            .pipe(map(providers => {
                const provider = providers.find(p => p.VideoStreamingProviderId == streamingProviderId);

                return provider;
            }));
    }

    // getPubSubClientUrl(userId): Observable<string> {
    //     if (!userId) {
    //         return of('');
    //     }
        
    //     const url = `${this.apiRoot}/aviator-online/pub-sub/negotiate?userId=${userId}`;

    //     return this.httpClient.get<string>(url);
    // }

    // publishBroadcastMessage(message: PubSubMessage): void {

    //     message.FromClient = VideoRepositoryService.eventClientId;
    //     const url = `${this.apiRoot}/aviator-online/pub-sub/broadcast`;

    //     this.httpClient.post(url, message).subscribe();
    // }

    // publishMessageToUser(userId: number, message: PubSubMessage): void {
    //     message.FromClient = VideoRepositoryService.eventClientId;

    //     const url = `${this.apiRoot}/aviator-online/pub-sub/user/${userId}`;

    //     this.httpClient.post(url, message).subscribe();
    // }

    // publishMessageToCurrentUser(message: PubSubMessage): void {
    //     const currentUser = this.dwSecurityUserService?.securityContext?.ApplicationUser;

    //     if (!currentUser) {
    //         return;
    //     }

    //     this.publishMessageToUser(currentUser.UserId, message);
    // }

    getVideoLibrary(streamingProvider: VideoStreamingProviderEntity, videoLibraryId: number): VideoLibraryEntity {
        return streamingProvider.VideoLibrary.find(v => v.VideoLibraryId == videoLibraryId);
    }


    getStreamingProviders(): Observable<VideoStreamingProviderEntity[]> {
        const cacheInvalidationTopics = [];

        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.VideoStreamingProvider));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.VideoLibrary));

        return this.dwCacheService.get('streaming-providers', this.loadStreamingProviders(), null, cacheInvalidationTopics);
    }

    getVideos(videoIds: number[]) : Observable<VideoEntity[]> {
        const query = AppMetaData.Video.CreateQueryBuilder();

        query.addFilterAnd(f => f.InList(a => a.VideoId, videoIds));


        return this.dwOrmDataService.executeQuery(query);
    }

    getVideoPreviewPlayback(videoId: number): Observable<VideoPreviewPlayback> {
        const url = `${this.apiRoot}/aviator-online/videos/preview/${videoId}/playback`;

        return this.httpClient.get<VideoPreviewPlayback>(url, {
            params: { supportsCdnAuthenticatedHlsPlayback: 'true' }
        });
    }

    getVideoThumbnailPreviews(videoIds: number[]): Observable<VideoThumbnailPreview[]> {
        const url = `${this.apiRoot}/aviator-online/videos/preview/thumbnails`;

        return this.httpClient.post<VideoThumbnailPreview[]>(url, { VideoIds: videoIds });
    }

    private loadStreamingProviders(): Observable<VideoStreamingProviderEntity[]> {
        const query = AppMetaData.VideoStreamingProvider.CreateQueryBuilder();

        query.addPrefetch(r => r.VideoLibrary);

        return this.dwOrmDataService.executeQuery(query);
    }

}
